import { ArrowLeftIcon, Box, Button, DeleteIcon, Stack, TextField, Tooltip, Typography, VisibilityOnIcon } from "convertupleads-theme";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectEmployerTemplateState } from "../../../state/employerTemplate/employerTemplateSelector";
import { useSelector } from "react-redux";
import { createEmployerTemplate, editEmployerTemplate, resetCreateEmployerTemplate, resetEditEmployerTemplate } from "../../../state/employerTemplate/employerTemplateSlice";
import { showErrorToaster } from "../../../helpers/utils/toaster";
import { isEmpty } from "../../../helpers/utils/tools";

const TemplateEditorHeader = ({ isCreated, isGenerating, docUrl, content, templateName, setName, onUpdateTemplate }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAdding, isAddSuccess, isUpdating, isUpdateSuccess, template } = useSelector(selectEmployerTemplateState);
  // const { value: openDeleteModal, setFalse: onCloseDeleteModal, setTrue: onOpenDeleteModal } = useBoolean(false);
  // const { value: openPdfPreview, setFalse: onClosePdfPreview, setTrue: onOpenPdfPreview } = useBoolean(false);

  // const handleDeleteConfirm = () => {
  //     dispatch(deleteMessageTemplate({ id: template?.id }));
  // };

  // const handleSaveTemplateName = () => {
  //     if (isEmpty(templateName)) {
  //         setName(template?.name);
  //     } else if (isCreated && template?.name !== templateName) {
  //         onUpdateTemplate(templateName, content);
  //         dispatch(setTemplateName({ name: templateName }));
  //     }
  // };

  // useEffect(() => {
  //     if (isDeleteSuccess) {
  //         navigate(-1);
  //         dispatch(resetDeleteMessageTemplate());
  //     }
  // }, [isDeleteSuccess, navigate, dispatch]);

  useEffect(() => {
    if (isAddSuccess || isUpdateSuccess) {
      dispatch(resetCreateEmployerTemplate());
      dispatch(resetEditEmployerTemplate());
      navigate(-1);
    }
  }, [isAddSuccess, isUpdateSuccess]);

  const handleSaveTemplate = () => {
    if (isEmpty(templateName)) {
      showErrorToaster("Template name is required");
      return;
    } else if (isEmpty(content)) {
      showErrorToaster("Write something on template");
      return;
    }
    console.log("template #", template);
    const data = {
      name: templateName,
      subject: "--",
      body: content,
      type: template?.category,
    };
    if (!isEmpty(template?.id)) {
      data.id = template?.id;
      dispatch(editEmployerTemplate(data));
    } else {
      dispatch(createEmployerTemplate(data));
    }
  };

  const isLoading = false;
  // const isLoading = isAdding || isUpdating || isDeleting || isGenerating;

  return (
    <>
      <Box sx={{ px: 3, py: 2, backgroundColor: "#fff" }}>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Button disabled={isLoading} size={"small"} color={"primary"} variant={"tonal"} startIcon={<ArrowLeftIcon />} onClick={() => navigate(-1)}>
              {"Back"}
            </Button>
          </Stack>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <TextField
              variant={"standard"}
              value={templateName}
              placeholder="Template Name..."
              onChange={(e) => setName(e.target.value)}
              // onBlur={handleSaveTemplateName}
              size={"small"}
              autoComplete={"off"}
            />
          </Stack>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            {/* {isLoading ? (
                            <Typography variant={'body2'}>{'Saving....'}</Typography>
                        ) : (
                            <Typography variant={'body2'}>{'All changes saved'}</Typography>
                        )} */}
            {/* <Tooltip title={'Preview'}>
                            <IconButton disabled={isLoading || !isCreated} onClick={onOpenPdfPreview}>
                            <VisibilityOnIcon fontSize={'small'} color={isLoading || !isCreated ? 'inherit' : 'primary'} />
                            </IconButton>
                        </Tooltip> */}
            <Button disabled={isAdding || isUpdating} size={"small"} color={"primary"} onClick={handleSaveTemplate}>
              {"Save"}
            </Button>
          </Stack>
        </Stack>
      </Box>

      {/* <ModalWithHeader title={templateName} width={'98vw'} open={openPdfPreview} onClose={onClosePdfPreview}>
                <PdfPreview pdfFile={{ id: template?.id, fileUrl: docUrl }} />
            </ModalWithHeader>

            <DeleteModal
                title={'Warning')}
                buttonText={'Discard')}
                warningContent={'Are you sure you want to discard this file? The file cannot be recovered once discarded.')}
                open={openDeleteModal}
                onClose={onCloseDeleteModal}
                onConfirm={handleDeleteConfirm}
                isLoading={isDeleting}
            /> */}
    </>
  );
};

export default TemplateEditorHeader;
